import { CompatibilityService } from "./compatibilityservice";
import { Observable as RxObservable } from 'rxjs';
import { AppVersion } from "../interfaces";
import { NavClientService, NavUrlService, INavUrlInfo } from "../navdata";
import { NavSettingsService } from "./settingsservice";
import { RwfSignalRService } from "../rwfsignalr";
import { IWebApiRoot } from "../navdata";
import { RwfBackend, RwfAutoResolver } from "../rwf";
import { IDialogService } from "./DialogService";

/** Description of a function to AutoResolve Object defined by structure */
export interface IAutoResolvable<TResolve> {
       /** Resolve Injection Token By its name */
       <TNames extends keyof TResolve>(inject: TNames): TResolve[TNames];
       /** Resolve given Injetion Tokens */
       <TNames extends keyof TResolve>(inject: TNames[]): Pick<TResolve, TNames>;
}

/** Declaration of a function to resolve abstracted Services */
export type NavAutoResolver = IAutoResolvable<INavBaseInjectable>;

/** AutoResolve Names for Nav Functionality  by Convention */
export interface INavBaseInjectable {
    "$c": CompatibilityService;
    "InfomaAppVersion": AppVersion;
    'NavClient': NavClientService;
    'NavUrl': NavUrlService;
    "NavSettings": NavSettingsService;
    "DialogService": IDialogService;
    "RwfSignalR": RwfSignalRService;
    "WebApiRoot": IWebApiRoot;
    "RwfBackend": RwfBackend;
    "Routing": IRoutingService;
    "Rwf": RwfAutoResolver;
};

export const Param_NavUrl = 'navurl';
export const Param_Company = 'company';

/** Routing Abstraction */
export interface IRoutingService {

    readonly CurrentUrl: string;
    readonly IsDlg?: boolean;

    /** Compat: mirror current context in url */
    SetCurrentNavContext(toSet: INavUrlInfo, defaultUrl: INavUrlInfo, lockReload: boolean);

    LockReload(action: ()  => void | PromiseLike<any>);

    Search(): any;
    Search(name: string): string;

    path(url: string): IRoutingService;

    // search: string, paramValue: string|number|null|string[]|boolean
    search(search: string, paramValue: string|number|null|string[]|boolean): IRoutingService;
    search(p: Record<string, string|number|null|string[]|boolean>): IRoutingService;

    /** Expose the Curent Route Information in a way that only after(first) init it will emit a value */
    readonly CurrentRoute: RxObservable<string>;
}
